import React, { useState } from 'react';
import {
  Route,
  Switch,
  useRouteMatch,
  withRouter,
} from 'react-router-dom';

import Dashboard from './statistics/dashboard';
import DetailedDashboard from './statistics/detailedDashboard';
import ListFormVariablesTechnical from './programs/listFormVariablesTechnical';
import ListProgramsTechnical from './programs/listProgramsTechnical';
import ProgramConfigurationTechnical from './programs/programConfigurationTechnical';

import NoMatch from './noMatch';

import { changeLang, getLang } from '../../languages/i18n';

function Technical() {
  const { path } = useRouteMatch();

  const [language, setLanguage] = useState(getLang());

  const changeLanguage = (lang) => {
    setLanguage(lang);
    changeLang(lang);
  };

  return (
    <Switch>      
      {/* +++++++++++++++++++++++++++++++++++++++++++++++ PROGRAMES +++++++++++++++++++++++++++++++++++++++++++++++ */}
      {/* ATENCIÓ: Posar key a la cridada EditProgramInfo */}      
      {/*
      <Route path={`${path}/editProgramInfo/:idProgram`}>
        <EditProgramInfo type='edit' key='editProgramInfo' lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      */}
      <Route path={`${path}/listFormVariables/:formName/:idProgram`}>
        <ListFormVariablesTechnical lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      <Route path={`${path}/listProgramsTechnical`}>
        <ListProgramsTechnical lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      <Route path={`${path}/programConfiguration/:idProgram`}>
        <ProgramConfigurationTechnical lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      <Route path={`${path}/dashboard`}>
        <Dashboard lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      <Route path={`${path}/detailed`}>
        <DetailedDashboard lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      {/* NO MATCH */}
      <Route path='*'>
        <NoMatch />
        {/* <Redirect to='/' /> // Alternativa a NoMatch, en lloc de mostrar NoMatch va directa a la pantalla d'inici */}
      </Route>
    </Switch>
  );
}

export default withRouter(Technical);
